import { render, staticRenderFns } from "./ChoosePersonUser.vue?vue&type=template&id=1761032e&scoped=true&"
import script from "./ChoosePersonUser.vue?vue&type=script&lang=js&"
export * from "./ChoosePersonUser.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePersonUser.vue?vue&type=style&index=0&id=1761032e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1761032e",
  null
  
)

export default component.exports